var ezdia;
(function (ezdia) {
    function getListItem(item) {
        var ezCategoryId = item.ezCategoryId, ezCategoryName = item.ezCategoryName, ezCategoryLeaf = item.ezCategoryLeaf;
        var leaf;
        var cat;
        if (ezCategoryLeaf) {
            leaf = 'leaf';
        }
        if (!ezCategoryLeaf) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            cat = "<div class=\"ez-category-select-link\">\n        <a href=\"javascript:void(0)\" data-row=\"select\" data-value=\"" + ezCategoryId + "\" data-label=\"" + ezCategoryName + "\">Select this</a>\n      </div>";
        }
        var ret = "<li data-value=\"" + ezCategoryId + "\" data-label=\"" + ezCategoryName + "\" data-leaf=\"" + leaf + "\" data-search=\"search\">\n      <div data-row=\"text\" class=\"ez-category-label\">" + ezCategoryName + "</div>\n    </li>";
        return ret;
    }
    var mainTemplate = function (context) {
        var boxID = context.boxID, pos = context.pos, searchID = context.searchID, listID = context.listID, list = context.list;
        var ret = "<div class=\"form-add-fields-edit-type-list ez-category-field-list\" data-row=\"box\" id=\"" + boxID + "\" style=\"left: " + pos.left + "; width: " + pos.width + "\">\n      <div class=\"form-add-fields-search\"><input type=\"text\" class=\"form-control\" id=\"" + searchID + "\" placeholder=\"Search\"></div>\n      <ul data-search-container=\"" + searchID + "\" id=\"" + listID + "\" class=\"list-unstyled\">\n        " + list.map(function (item) { return getListItem(item); }) + "\n      </ul>\n    </div>";
        return ret;
    };
    var templates;
    (function (templates) {
        templates.entity = {
            mainTemplate: mainTemplate
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
